












import {Vue, Component} from 'vue-property-decorator';
import editor from '@/components/common/summernote/Index.vue';
@Component({
  components: {
    editor
  }
})
export default class PopupCouponGuide extends Vue {
  private getGuideImageUrl: string = '';
  private guideImageUrl: string = '';

  private editorOptions = {
    width: 475,
    height: 200,
    toolbar: [
      ['fontsize', ['fontsize']],
      ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
      ['color', ['color']],
      ['para', ['paragraph']],
      ['height', ['height']],
      ['picture', ['picture']],
      ['misc', ['codeview']]
    ]
  };
  private guideImageUrlOnChange({html}: {html: any}) {
    this.guideImageUrl = html;
  }

  private mounted() {
    this.init();
  }
  private init() {
    let guideImageUrlSession = sessionStorage.getItem('guideImageUrl') as string;
    this.getGuideImageUrl = guideImageUrlSession;
  }

  private applyBtnClick() {
    let info = this.guideImageUrl;
    $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}(${JSON.stringify(info)});`);
    self.close();
  }
  private cancelBtnClick() {
    self.close();
  }
}
